import React from 'react';

const CvMakerContext = React.createContext();
export default CvMakerContext;